import ajax from '@/utils/ajax';

export const head = '/web';
export const reqCouponList = (data) => ajax(`${head}/v1/coupon/user/coupons`, data, 'POST'); // 获取优惠卷列表
export const reqCourseList = (status, type) =>
  ajax(`${head}/v1/user/course/course-list?status=${status}&type=${type}`); // 获取我的课程列表
export const delOverdueCourses = () => ajax(`${head}/v1/user/course/delete`, '', 'DELETE'); // 删除过期课程

// 个人中心版本记录
export const reqVersionRecord = (data) => ajax(`${head}/v1/user/exam/choose-records`, data, 'POST');

// 拼团
// 拼团订单列表
export const reqGetGroupOrderList = (data) => ajax(`${head}/v1/group-order/list`, data, 'GET');
// 拼团订单详情
export const reqGetGroupOrderDetail = (data) => ajax(`${head}/v1/group-order/detail`, data, 'GET');

// 拉新
export const reqPullNewList = (data) => ajax(`${head}/v1/pull-new/activity/list`, data, 'GET');

// 退换货物流信息
export const reqExpressRecordDetail = (id) =>
  ajax(`${head}/v1/return-express-record/detail-front?id=${id}`, '', 'GET');
export const reqExpressRecordEdit = (data) =>
  ajax(`${head}/v1/return-express-record/edit-user`, data, 'POST');

// 获取我的游戏列表
export const reqMyGameList = (data) =>
  ajax(`${head}/v1/contact-thing/user-score-info`, data, 'POST');

// 获取B站-方舟产品映射已上架产品信息
export const reqOnlineProduct = () =>
  ajax(`${head}/v1/bilibili-product-reflection/online-product-info`, '', 'GET');

// 用户添加订单
export const reqBiliOrderAdd = (data) =>
  ajax(`${head}/v1/order/bilibili-order/front/add`, data, 'POST');

// 用户端-订单详情
export const reqBiliOrderDetail = (id) =>
  ajax(`${head}/v1/order/bilibili-order/front/detail?id=${id}`, '', 'GET');

// 用户编辑订单

export const reqBiliOrderEdit = (data) =>
  ajax(`${head}/v1/order/bilibili-order/front/edit`, data, 'POST');

// 用户端-地址详情
export const reqBiliAddress = (id) =>
  ajax(`${head}/v1/order/bilibili-order/front/address?id=${id}`, '', 'GET');

// 用户修改地址
export const reqBiliAddressEdit = (data) =>
  ajax(`${head}/v1/order/bilibili-order/front/edit-address`, data, 'POST');


  // 开具发票接口
  export const reqInvoiceIssue = (data) =>
  ajax(`${head}/v1/invoice/issue`, data, 'POST');

  // 查询订单开具的发票
  export const reqInvoiceDetail = (orderNo) =>
  ajax(`${head}/v1/invoice/front-detail?orderNo=${orderNo}`, '', 'GET');
